module.exports = __webpack_public_path__ + "img/bg-2.7e252797.jpg";